<template>
    <v-dialog v-model="vDialogLoadMiddle" scrollable persistent max-width="1300px">
        <v-card>
            <v-toolbar color="primary" dense dark>
                <v-spacer></v-spacer>
                    Possible Middles Loads
                <v-spacer></v-spacer>
                <v-btn icon @click="$emit('close')"><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>
            <v-container grid-list-xs>
                <v-card>
                    <v-toolbar dense>
                        Shift Qualifications
                    </v-toolbar>
                </v-card>
                <v-container grid-list-xs>
                    <v-simple-table dense>
                        <thead>
                            <tr>
                                <th class="text-center">ShiftDetail</th>
                                <th class="text-center" colspan="3">Driver</th>
                                <th class="text-center" colspan="2">Truck</th>
                                <th class="text-center" colspan="2">Trailer</th>
                                <th class="text-center" colspan="2">Yard</th>
                                <th class="text-center" colspan="1">Region</th>
                                <th class="text-center" colspan="1">Time Available</th>
                                <th class="text-center" v-if="LoadsInfoMiddle.Shifts.Pump">PumpCall</th>
                                <th class="text-center" v-if="LoadsInfoMiddle.Shifts.Quad">QuadCall</th>
                                <th class="text-center" v-if="LoadsInfoMiddle.Shifts.Strait">Strait</th>
                                <th class="text-center" v-if="LoadsInfoMiddle.Shifts.isSpecific">Specific Product</th>
                            </tr>
                        </thead>
                       <tbody>
                            <tr>
                                <td>{{ LoadsInfoMiddle.Shifts.ShiftDetail }}</td>
                                <td colspan="3">{{ LoadsInfoMiddle.Shifts.DriverName }}</td>
                                <td colspan="2">{{ LoadsInfoMiddle.Shifts.Truck }}</td>
                                <td colspan="2">{{ LoadsInfoMiddle.Shifts.Trailer }}</td>
                                <td colspan="2">{{ LoadsInfoMiddle.Shifts.Yard }}</td>
                                <td colspan="1">{{ LoadsInfoMiddle.Shifts.Region }}</td>
                                <td colspan="1">{{ LoadsInfoMiddle.Shifts.HrsAviable }}</td>

                                <td v-if="LoadsInfoMiddle.Shifts.Pump"><v-icon
                                        color="success">mdi-check-circle-outline</v-icon></td>
                                <td v-if="LoadsInfoMiddle.Shifts.Quad"><v-icon
                                        color="success">mdi-check-circle-outline</v-icon></td>
                                <td v-if="LoadsInfoMiddle.Shifts.Strait"><v-icon
                                        color="success">mdi-check-circle-outline</v-icon></td>
                                <td class="text-center" v-if="LoadsInfoMiddle.Shifts.isSpecific"><v-icon
                                        color="success">mdi-check-circle-outline</v-icon></td>
                            </tr> 
                            <tr>
                                <th @click="setSortBy('OrderID')" class="text-center">OrderID</th>
                                <th @click="setSortBy('OrderStatus')"  class="text-center">OrderStatus</th>
                                <th @click="setSortBy('TerminalName')"  class="text-center">Terminal</th>
                                <th @click="setSortBy('StationName')"  class="text-center">Station</th>
                                <!-- <th @click="setSortBy('CustomerName')"  class="text-center">Customer</th> -->
                                <th @click="setSortBy('distance_in_kilometers')" class="text-center">Distance - Sta/Ter</th>
                                <th @click="setSortBy('distance_in_kilometers')" class="text-center">Time</th>
                                <th @click="setSortBy('RTHrs')"  class="text-center" colspan="1">RTHrs</th>
                                <th @click="setSortBy('ROHrs')"  class="text-center" colspan="1">ROHrs</th>
                                <th   class="text-center" colspan="1">Region</th>
                                <!-- <th @click="setSortBy('LoadCarding')"  class="text-center">Load Bagde</th>
                                <th @click="setSortBy('UnLoadCarding')" class="text-center" v-if="LoadsInfoMiddle.order.IsTerminal">Off Load Bagde</th> -->
                                <th class="text-center">PumpCall</th>
                                <th class="text-center">QuadCall</th>
                                <th class="text-center">Strait</th>
                                <th class="text-center" v-if="LoadsInfoMiddle.Shifts.isSpecific">Specific Product</th>
                                <th>UnLoad</th>
                            </tr>
                            <tr v-for="ql in sortedLoads">
                                <td class="text-center">{{ ql.OrderID }}</td>
                                <td class="text-center">{{ ql.OrderStatus }}</td>
                                <td class="text-center">{{ ql.TerminalName }}</td>
                                <td class="text-center">{{ ql.StationName }}</td>
                                <!-- <td class="text-center">{{ ql.CustomerName }}</td> -->
                                <td class="text-center">{{ ql.distance_in_kilometers }}</td>
                                <td class="text-center">{{ ql.AVGHE }}</td>
                                <td class="text-center" :style="ql.RTHrs < 3 ? 'color:#000;':'color:red;'" >{{ Number(ql.RTHrs).toFixed(0) }}</td>
                                <td class="text-center">{{ ql.ROHrs }}</td>
                                <td class="text-center"><v-icon
                                        :color="ql.PrincipalRegionID == LoadsInfoMiddle.Shifts.PrincipalRegion ? 'success' : 'red'">{{
                                            ql.PrincipalRegionID == LoadsInfoMiddle.Shifts.PrincipalRegion ?
                                        'mdi-check-circle-outline' :'mdi-close-circle' }}</v-icon></td>
                                <td class="text-center">
                                    <v-icon
                                        :color="ql.PumpCall == 1 ? 'success' : ql.PumpCall == 2 ? '#000' : 'red'">
                                        {{ ql.PumpCall == 1? 'mdi-check-circle-outline' : ql.PumpCall == 2 ? 'mdi-minus-circle-off-outline' :'mdi-close-circle'}}
                                        </v-icon>
                                </td>
                                <td class="text-center">    
                                        <v-icon
                                        :color="ql.QuadCall == 1 ? 'success' : ql.QuadCall == 2 ? '#000' : 'red'">
                                        {{ ql.QuadCall == 1? 'mdi-check-circle-outline' : ql.QuadCall == 2 ? 'mdi-minus-circle-off-outline' :'mdi-close-circle'}}
                                        </v-icon>
                                </td>
                                <td class="text-center">
                                    
                                        <v-icon
                                        :color="ql.StraitTruck == 1 ? 'success' : ql.StraitTruck == 2 ? '#000' : 'red'">
                                        {{ ql.StraitTruck == 1? 'mdi-check-circle-outline' : ql.StraitTruck == 2 ? 'mdi-minus-circle-off-outline' :'mdi-close-circle'}}
                                        </v-icon>
                                    
                                </td>
                                <td class="text-center" v-if="LoadsInfoMiddle.Shifts.isSpecific">
                                    
                                    <v-icon
                                        :color="ql.isSpecific == 1 ? 'success' : ql.isSpecific == 2 ? '#000' : 'red'">
                                        {{ ql.isSpecific == 1? 'mdi-check-circle-outline' : ql.isSpecific == 2 ? 'mdi-minus-circle-off-outline' :'mdi-close-circle'}}
                                        </v-icon>
                                </td>
                                <td>
                                    <v-icon
                                        :color="ql.UnLoad == 1 ? 'success' : ql.UnLoad == 2 ? '#000' : 'red'">
                                        {{ ql.UnLoad == 1? 'mdi-check-circle-outline' : ql.UnLoad == 2 ? 'mdi-minus-circle-off-outline' :'mdi-close-circle'}}
                                        </v-icon>
                                </td>
                            </tr>
                            <!-- 
                            <tr v-for="ql in sortedLoads">
                                <td class="text-center">{{ ql.ShiftDetail }}</td>
                                <td class="text-center">{{ ql.Driver }}</td>
                                <td class="text-center">{{ ql.Truck }}</td>
                                <td class="text-center">{{ ql.Trailer }}</td>
                                <td class="text-center">{{ ql.Yard }}</td>
                                <td class="text-center">{{ ql.NewAvialable }}</td>
                                <td class="text-center">{{ ql.distance_in_kilometers_yard_end }}</td>
                                    <td class="text-center">{{ ql.distance_in_kilometers_station_terminal }}</td>
                                <td class="text-center"><v-icon
                                        :color="ql.PrincipalRegionID == LoadsInfoMiddle.order.Region ? 'success' : 'red'">{{
                                            ql.PrincipalRegionID == LoadsInfoMiddle.order.Region ?
                                        'mdi-check-circle-outline' :'mdi-close-circle' }}</v-icon></td>
                                <td class="text-center"><v-icon :color="ql.LoadCarding == true ? 'success' : 'red'">{{
                                    ql.LoadCarding == true ? 'mdi-check-circle-outline' :'mdi-close-circle'
                                        }}</v-icon></td>
                                <td class="text-center" v-if="LoadsInfoMiddle.order.IsTerminal > 0"><v-icon
                                        :color="ql.UnLoadCarding == true ? 'success' : 'red'">{{ ql.UnLoadCarding == true
                                            ? 'mdi-check-circle-outline' :'mdi-close-circle' }}</v-icon></td>
                                <td class="text-center" v-if="LoadsInfoMiddle.order.PumpCall"><v-icon
                                        :color="ql.PumpCall == true ? 'success' : 'red'">{{ ql.PumpCall == true ?
                                        'mdi-check-circle-outline' :'mdi-close-circle' }}</v-icon></td>
                                <td class="text-center" v-if="LoadsInfoMiddle.order.QuadCall"><v-icon
                                        :color="ql.QuadCall == true ? 'success' : 'red'">{{ ql.QuadCall == true ?
                                        'mdi-check-circle-outline' :'mdi-close-circle' }}</v-icon></td>
                                <td class="text-center" v-if="LoadsInfoMiddle.order.StraitTruck"><v-icon
                                        :color="ql.StraitTruck == true ? 'success' : 'red'">{{ ql.StraitTruck == true ?
                                        'mdi-check-circle-outline' :'mdi-close-circle' }}</v-icon></td>
                                <td class="text-center" v-if="LoadsInfoMiddle.order.isSpecific"><v-icon
                                        :color="ql.isSpecific == 1 ? 'success' : 'red'">{{ ql.isSpecific == 1 ?
                                        'mdi-check-circle-outline' :'mdi-close-circle' }}</v-icon></td>
                            </tr>-->
                        </tbody> 
                    </v-simple-table>
                </v-container>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    props: ['vDialogLoadMiddle', 'LoadsInfoMiddle'],
    data: function () {
        return {

            sortOrder: 'asc', // Puede ser 'asc' o 'desc'
            sortBy: 'ROHrs' // La propiedad por la que deseas ordenar
        }
    },
    computed: {
        sortedLoads() {
            return this.LoadsInfoMiddle.Home.sort((a, b) => {
                const isAsc = this.sortOrder === 'asc' ? 1 : -1;
                
                // Verificar si el campo a ordenar es una fecha
                if (this.sortBy === 'ROHrs') {
                    return isAsc * (new Date(a.ROHrs) - new Date(b.ROHrs));
                }
                
                // Verificar si el campo a ordenar es un número
                if (typeof a[this.sortBy] === 'number' && typeof b[this.sortBy] === 'number') {
                    return isAsc * (a[this.sortBy] - b[this.sortBy]);
                }
                
                // Ordenar por strings o cualquier otro tipo
                return isAsc * a[this.sortBy].toString().localeCompare(b[this.sortBy].toString());
            });
        }
    },
    mounted() {
        this.deleteDuplicatesByOrderID(this.LoadsInfoMiddle.Home);
    },
    methods: {
        deleteDuplicatesByOrderID: function(array) {
            const vistos = new Set();
            const resultado = [];

            array.forEach(home => {
                if (!vistos.has(home.OrderID)) {
                    vistos.add(home.OrderID);
                    resultado.push(home);
                }
            });

            return resultado;
        },
        setSortBy(field) {
            if (this.sortBy === field) {
                // Si se hace clic en el mismo campo, alternar el orden
                this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
            } else {
                this.sortBy = field;
                this.sortOrder = 'asc';
            }
        }
    }
}
</script>